<template>
  <f-dashboard-fullscreen-layout>
    <template #sidebar-header>
      <router-link 
        :to="{ name: 'roles-list' }"
        @click.prevent="goBack"
      >
        <i class="uil uil-angle-left"></i> Fermer
      </router-link>
    </template>

    <template #sidebar-title>
      Éditer le rôle
    </template>

    <template #content>
      <div class="max-width-500 is-margin-auto">
        <router-view v-if="role"></router-view>
      </div>
    </template>

    <template #content-footer>
      <f-button
        class="is-full"
        @click="editRole"
        fill 
      >
        Sauvegarder
      </f-button>
    </template>
  </f-dashboard-fullscreen-layout>
</template>

<script>
  import { computed, nextTick } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'

  export default {
    async setup () {
      const { get, fetch, patch } = useStore('@admin/roles')

      const roleId = computed(() => router.currentRoute.value.params.role_id)
      const role = computed(() => get(roleId.value))

      if (!role.value) {
        await fetch(roleId.value)
      }

      function goBack () {
        router.push({
          name: 'admins-list'
        })
      }

      async function editRole() {
        const data = {
          name: role.value.name,
          slug: role.value.slug,
          permissions: role.value.permissions,
        }

        try {
          await patch(roleId.value, data)

          // nextTick(goBack)
        } catch (error) {
          console.log('ERROR', error)
        }
      }

      return {
        roleId,
        role,
        goBack,
        editRole,
      }
    } 
  }
</script>